import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import * as VisuallyHidden from '@radix-ui/react-visually-hidden'
import PaymentMethodAddCard from './payment-method-add-card'
import PaymentMethodAddACH from './payment-method-add-ach'
import PaymentMethodStripeWrapper from './payment-method-stripe-warpper'

interface Props {
  open: boolean
  onOpenChange: () => void
}

export default function PaymentMethodDialogAdd({ open, onOpenChange }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="!gap-[30px] max-w-5xl"
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <DialogHeader className="">
          <DialogTitle>New Payment Method</DialogTitle>
          <VisuallyHidden.Root>
            <DialogDescription />
          </VisuallyHidden.Root>
        </DialogHeader>
        <div className="w-full">
          <Tabs defaultValue="credit-card" className="w-full">
            <TabsList className="flex flex-row gap-4 !px-0 !py-0 w-fit">
              <TabsTrigger
                className={`rounded-[32px] px-2 py-1.5 text-primary border-primary border ring-primary ring-1
                data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:border-none
                `}
                value="credit-card"
              >
                Credit/Debit Card
              </TabsTrigger>
              <TabsTrigger
                className={`rounded-[32px] px-2 py-1.5 text-primary border-primaryr ring-primary ring-1
                 data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:border-none
                `}
                value="ach"
              >
                ACH Payment
              </TabsTrigger>
            </TabsList>
            <TabsContent value="credit-card">
              <PaymentMethodStripeWrapper>
                <PaymentMethodAddCard onOpenChange={onOpenChange} />
              </PaymentMethodStripeWrapper>
            </TabsContent>
            <TabsContent value="ach">
              <PaymentMethodAddACH onOpenChange={onOpenChange} />
            </TabsContent>
          </Tabs>
        </div>
      </DialogContent>
    </Dialog>
  )
}
